(function () {
    'use strict';
    var controllerId = 'accreditamentoSedeAdd';
    angular.module('app').controller(controllerId, ['$scope', 'datacontext', 'sectionMenu', '$uibModalInstance', 'accredSede', 'province', 'accreditamentoId', 'progettoId', accreditamentoSedeAdd]);

    function accreditamentoSedeAdd($scope, datacontext, sectionMenu, $uibModalInstance, accredSede, province, accreditamentoId, progettoId) {
        $scope.province = province;
        $scope.comuni = [];

        $scope.getComuni = getComuni;

        if (accredSede) {
            $scope.title = 'Modifica Sede';
            $scope.accreditamentoSede = jQuery.extend({}, accredSede); //Clona oggetto
            getComuni($scope.accreditamentoSede.ProvinciaId);
        }
        else {
            $scope.title = 'Nuova Sede';
            $scope.accreditamentoSede = {};
            $scope.accreditamentoSede.Id = 0;
        }

        //Impostazioni per calendario dateTimePicker
        $scope.datepickers = {};
        $scope.today = function () {
            $scope.dt = new Date();
        };
        $scope.today();

        $scope.clear = function () {
            $scope.dt = null;
        };

        // Disable weekend selection
        $scope.disabled = function (date, mode) {
            return (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
        };

        $scope.toggleMin = function () {
            $scope.minDate = $scope.minDate ? null : new Date();
        };
        $scope.toggleMin();
        $scope.dateOptions = {
            formatYear: 'yyyy',
            formatMonth: 'MM',
            startingDay: 1
        };

        $scope.openCalendar = function ($event, iOpened) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened1 = false;
            if (iOpened == 1)
                $scope.opened1 = true;
        };

        if (progettoId) {
            $scope.progettoId = progettoId;
        }

        if (accreditamentoId) {
            $scope.accreditamentoId = accreditamentoId;
            $scope.accreditamentoSede.CNDAccreditamentoId = accreditamentoId;
        }


        function getComuni(idprov) {
            if (!idprov || idprov == 0) return $scope.comuni = [];

            if ($scope.accreditamentoSede.ProvinciaId != idprov)
                $scope.comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return $scope.comuni = data;
            });
        }

        $scope.ok = function (isValid) {
            if (isValid) {
                if ($scope.accreditamentoSede.Id == 0) {
                    var result = addItem($scope.accreditamentoSede);
                    $uibModalInstance.close(result);
                }
                else {
                    var result2 = updateItem($scope.accreditamentoSede);
                    $uibModalInstance.close(result2);
                }
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            return datacontext.cndAccreditamentoSede_add(item).then(function (data) {
                if (!data) return null;

                return data;
            });
        }

        function updateItem(item) {
            return datacontext.cndAccreditamentoSede_update(item).then(function (data) {
                if (!data) return null;

                return data;
            });
        }

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-EXISTS cndAccreditamento SEDE -#-#-#-#-#-#
        $scope.existsSede = false;
        $scope.searchSede = function (value) {
            console.log('searchSede()');
            $scope.existsSede = false;
            return datacontext.cndAccreditamentoSede_exists($scope.progettoId, $scope.accreditamentoSede.CNDAccreditamentoId, value).then(function (data) {
                //console.info('data', data);
                $scope.existsSede = data;
            });
        };

    }
})();